import React from 'react';
import { GiftCardStatusTag } from '../../../../components/GiftCardStatusTag/GiftCardStatusTag';
import { GiftCardTableCell } from '../GiftCardTableCell/GiftCardTableCell';
import { GiftCardUsageTableCell } from '../GiftCardUsageTableCell/GiftCardUsageTableCell';
export const TABLE_HEADERS = [
    {
        id: 'code',
        label: 'Gift cards',
        render: (giftCard) => React.createElement(GiftCardTableCell, { giftCard: giftCard }),
        width: 6,
    },
    {
        id: 'status',
        label: 'Status',
        render: (giftCard) => React.createElement(GiftCardStatusTag, { status: giftCard.status }),
        width: 2,
    },
    {
        id: 'used',
        label: 'Current / Initial',
        render: (giftCard) => React.createElement(GiftCardUsageTableCell, { giftCard: giftCard }),
        width: 2,
    },
];
